// extracted by mini-css-extract-plugin
var _1 = "AIButtonOutlined-moduleaiButtonOutlined__Yxl0S";
var _2 = "AIButtonOutlined-moduleaiButtonOutlinedLabel__o7MRK";
var _3 = "AIButtonOutlined-moduleskeleton__Jqmu8";
export { _1 as "aiButtonOutlined", _2 as "aiButtonOutlinedLabel", _3 as "skeleton" }
